<template>
<center>
    <div class="card card-body agatrs-card-style">
        <div class="col-md-12">
            <Header pageTitle="Create New 'Bill to' / 'Pay to' Office" class="card-container"></Header>
            <div class="row">
                <div class="col-md-3">
                    <label>Country</label>
                    <v-select 
                        v-model="financeOffice['countryId']" 
                        name="CountryDropdown" 
                        :reduce="item => item.countryId" 
                        label="name" 
                        :options="countriesOptions" 
                        placeholder="Please select a country."
                        v-validate="'required'"
                        data-vv-as="Country"
                        :class="errors.has('CountryDropdown') ? 'has-danger' : ''"
                    ></v-select>
                    <span v-show="errors.has('CountryDropdown')" class="error">
                        {{ errors.first("CountryDropdown") }}
                    </span>
                </div>
                <div class="col-md-3">
                    <label>Name</label>
                    <base-input 
                        v-model="financeOffice['name']" 
                        name="Name" 
                        placeholder="Please enter a name."
                        v-validate="'required'"
                        data-vv-as="Name"
                        :error="getError('Name')"
                    ></base-input>
                </div>
                <div class="col-md-3">
                    <label>Email</label>
                    <base-input 
                        v-model="financeOffice['email']" 
                        name="Email" 
                        placeholder="Please enter an email."
                        v-validate="'required|email'"
                        data-vv-as="Email"
                        :error="getError('Email')"
                    ></base-input>
                </div>
                <div class="col-md-3">
                    <label>Address</label>
                    <base-input 
                        v-model="financeOffice['address']" 
                        name="Address" 
                        placeholder="Please enter an address."
                        v-validate="'required'"
                        data-vv-as="Address"
                        :error="getError('Address')"
                    ></base-input>
                </div>
            </div>
            <div class="row">
                <div class="col-md-3 offset-md-3">
                    <label>DSN Phone Number</label>
                    <base-input 
                        v-model="financeOffice['dsnPhoneNumber']" 
                        name="DsnPhoneNumber" 
                        placeholder="Please enter a DSN phone number."
                    ></base-input>
                </div>
                <div class="col-md-3">
                    <label>Commercial Phone Number</label>
                    <base-input 
                        v-model="financeOffice['commercialPhoneNumber']" 
                        name="CommercialPhoneNumber" 
                        placeholder="Please enter a commercial phone number."
                    ></base-input>
                </div>
            </div>

            <div class="row">
                <div class="col-md-2 align-left">
                    <base-button @click="returnToEditFinanceOfficesDashboard()" class="btn btn-dark" v-b-popover.hover.bottom="'Navigate back to edit finance offices dashboard.'">
                        <i class="tim-icons icon-double-left"></i> Back
                    </base-button>
                </div>
                <div class="col-md-2 offset-md-3 align-left">
                    <base-button @click="validateAndAddFinanceOffice()" type="primary" v-b-popover.hover.bottom="'Save changes.'">
                        <i class="tim-icons icon-bank"></i> Add Finance Office
                    </base-button>
                </div>
            </div>

        </div>
    </div>
</center>
</template>

<script>
import Header from "@/components/App/Header.vue";
import axios from "@/axios";
import {
    mapGetters,
    mapActions
} from "vuex";

export default {
    name: 'AdminCreateFinanceOffice',
    components: {
        Header
    },
    data() {
        return {
            financeOffice: {
                countryId: '',
                name: '',
                email: '',
                address: '',
                dsnPhoneNumber: '',
                commercialPhoneNumber: ''
            }
        };
    },
    computed: {
        ...mapGetters({
            countriesOptions: 'countries/allCountries'
        }),
    },
    mounted() {
        this.getAllCountries();
        this.getFinanceOfficesFromBackend();
    },
    methods: {
        ...mapActions({
            getAllCountries: 'countries/getAllCountries'
        }),
        returnToEditFinanceOfficesDashboard() {
            this.$router.push('/Admin/FinanceOffices')
        },
        getError(fieldName) {
            return this.errors.first(fieldName);
        },
        validateAndAddFinanceOffice() {
            this.$validator.validateAll().then(result => {
                if (result) {
                    this.addFinanceOffice();
                } else {
                    // Get all field errors
                    const fieldErrors = Object.keys(this.fields).map(field => {
                        if (this.errors.has(field)) {
                            return {
                                field: this.fields[field].name,
                                message: this.errors.first(field)
                            };
                        }
                        return null;
                    }).filter(error => error !== null);
                    
                    if (fieldErrors.length > 0) {
                        if (fieldErrors.length === 1) {
                            // Only one field 
                            this.$toast.error(fieldErrors[0].message);
                        } else {
                            // Multiple fields not entered
                            this.$toast.error("Please complete required fields");
                        }
                    } else {
                        this.$toast.error("Please complete required fields");
                    }
                }
            });
        },
        addFinanceOffice() {
            // Check for required fields to ensure server validation passes
            const missingFields = [];
            
            if (!this.financeOffice.countryId) missingFields.push("Country");
            if (!this.financeOffice.name) missingFields.push("Name");
            if (!this.financeOffice.email) missingFields.push("Email");
            if (!this.financeOffice.address) missingFields.push("Address");
            
            if (missingFields.length > 0) {
                if (missingFields.length === 1) {
                    // Only one field is missing
                    this.$toast.error(`The ${missingFields[0]} field is required`);
                } else {
                    // Multiple fields are missing
                    this.$toast.error("Please complete required fields");
                }
                return;
            }
            
            axios
                .post("api/financialoffices", this.financeOffice)
                .then((response) => {
                    this.$router.push('/Admin/FinanceOffices')
                })
                .catch(error => {
                    if (error.response && error.response.data) {
                        this.$toast.error(error.response.data);
                    } else {
                        this.$toast.error("Error creating finance office. Please try again.");
                    }
                });
        }
    }
};
</script>

<style>
.error {
  color: #ec250d;
  font-size: 0.75rem;
  margin-top: 2px;
  display: block;
}

.has-danger .vs__dropdown-toggle {
  border-color: #ec250d !important;
}
</style>
